import { defineComponent as _defineComponent } from 'vue'
import AdminNavigation from "../../AdminNavigationContainer.vue";
import { ref, onMounted, onBeforeUnmount, reactive, onUpdated } from "vue";
import FAQInfoDataService from "@/services/FAQInfoDataService";
import { useI18n } from "vue3-i18n";
import ResponseData from "@/types/ResponseData";
import Loading from "@/components/home/Loading.vue";
import Alert from "@/components/scan/parts/Alert.vue";
import { store } from "@/store/store";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false);
const alertMessage = ref("");
const alertState = ref("");
const menuTitle = ref("Q&A Maintenance");
const faqList = reactive([]);
const currentFile = ref("");
const currentSubject = ref("");
const modalTitle = ref("");
const buttonName = ref("");
const i18n = useI18n();

const rowId = ref(0);
const subject = ref("");
const content = ref("");
const uploadFile = reactive([]);
const todayDate = ref("");
const deleteId = ref(0);

const subjectError = ref("");
const fileContentError = ref("");

onMounted(() => {
  window.addEventListener('resize', handleResize);
  isLoading.value = true;
  getAllFAQ();
  const today = new Date();
  todayDate.value = today.toISOString().split("T")[0];
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', handleResize);
});

function handleResize() {
  try {
    var faqTableHeight = 0;
    var faqDataHeight = document.getElementById("tblfaqtbody")?.clientHeight;
    if (faqDataHeight != 0) {
      faqTableHeight = document.getElementById("tblfaqbodydiv")?.clientHeight;
      if (faqDataHeight >= faqTableHeight) {
        document.getElementById("tblfaqbodydiv").style.width = "80%";
      } else {
        document.getElementById("tblfaqbodydiv").style.width = "calc(80% - 16px)";
      }
    }
  } catch (e) {
    isLoading.value = false;
  }
}

onUpdated(() => {
  handleResize();
});

const getAllFAQ = () => {
  faqList.splice(0);
  const data = { userid: store.getters.cognitoUserName };
  isLoading.value = true;
  FAQInfoDataService.getAllFAQ(data).then((response: ResponseData) => {
    if (response.data.length != 0) {
      for (let info of response.data) {
        faqList.push(info);
      }
    }
    isLoading.value = false;
  });
};

const onClickAddButton = () => {
  modalTitle.value = "Add Q&A Information";
  buttonName.value = "Add";

  subject.value = "";
  content.value = "";
  clearErrorMsg();

  uploadFile.splice(0);
};

const onClickEditButton = (id: any) => {
  modalTitle.value = "Edit Q&A Information";
  buttonName.value = "Update";
  uploadFile.splice(0);
  clearErrorMsg();

  const data = { id: id };

  FAQInfoDataService.getRowFAQ(data)
    .then((response: ResponseData) => {
      rowId.value = response.data.id;
      subject.value = response.data.Subject;
      currentSubject.value = response.data.Subject;
      currentFile.value = response.data.Content;
      content.value = response.data.Content.split("/").at(-1);
    })
    .catch((error: Error) => {
      console.log(error);
    });
};

const clearErrorMsg = () => {
  alertMessage.value = "null";
  alertState.value = "neutral";

  subjectError.value = "";
  fileContentError.value = "";
}

const isInputOk = (inputData: any) => {
  clearErrorMsg();
  var isInputOk = true;
  if(inputData.subject.trim() == ""){
    subjectError.value = i18n.t("alt044");
    isInputOk = false;
  }
  if(inputData.fileContent == ""){
    fileContentError.value = i18n.t("alt056");
    isInputOk = false;
  }else if(typeof(inputData.fileContent) != "string" && !inputData.fileContent[0].name.toLowerCase().endsWith('.pdf')){
    fileContentError.value = i18n.t("alt080");
    isInputOk = false;
  }
  return isInputOk;
}

const AddFAQ = () => {
  var checkData = {
    subject: subject.value,
    fileContent: uploadFile
  }
  if(isInputOk(checkData)){
    isLoading.value = true;
    var id = 0;
    var formData = new FormData();
    formData.append("id", String(id));
    formData.append("Subject", subject.value);
    formData.append("File", uploadFile[0]);

    FAQInfoDataService.addFAQ(formData)
      .then((response: ResponseData) => {        
        var insertedFAQ = response.data.insertedFAQ;
        const newFAQList = Array.from(faqList);
        faqList.splice(0);
        faqList.push(insertedFAQ[0]);
        for(let faqObj of newFAQList){
          faqList.push(faqObj);
        }
        alertMessage.value = i18n.t("suc011");
        alertState.value = "success";
        isLoading.value = false;
      })
      .catch((error: Error) => {
        if (error.response.status == 500) {
          alertMessage.value = "The file must be PDF type.";
        } else if (error.response.status == 400 || error.response.status == 409) {
          alertMessage.value = error.response.data.message;
        }
        alertState.value = "error";
        isLoading.value = false;
      });
      document.getElementById("cancel")?.click();
    } else {
      return;
    }
};

const updateFAQ = () => {
  var checkData = {
    subject: subject.value,
    fileContent: uploadFile == ""? currentFile.value: uploadFile,
  }
  if(isInputOk(checkData)){
    isLoading.value = true;
    var formData = new FormData();
    formData.append("id", String(rowId.value));
    formData.append("Subject", subject.value);
    formData.append("currentFile", currentFile.value);
    formData.append("currentSubject", currentSubject.value);
    if (uploadFile != "") {
      formData.append("fileUpdate", "1");
      formData.append("File", uploadFile[0]);
    } else {
      formData.append("fileUpdate", "0");
    }
    
    FAQInfoDataService.updateFAQ(formData)
      .then((response: ResponseData) => {        
        var updatedFAQ = response.data.updatedFAQ;
        var newFAQList = Array.from(faqList);
        faqList.splice(0);
        for(let faqObj of newFAQList){
          if(updatedFAQ[0].id == faqObj.id){
            faqList.push(updatedFAQ[0]);
          }else{
            faqList.push(faqObj);
          }
        }

        alertMessage.value = i18n.t("suc016");
        alertState.value = "success";
        uploadFile.splice(0);
        isLoading.value = false;
      })
      .catch((error: ResponseData) => {
        if (error.response.status == 500) {
          alertMessage.value = i18n.t("alt066");
        } else {
          alertMessage.value = error.response.data.message;
        }
        alertState.value = "error";
        isLoading.value = false;
      });
    document.getElementById("cancel")?.click();
  } else {
    return;
  }
};

const getDeleteId = (id: any) => {
  deleteId.value = id;
};

const deleteFAQ = () => {
  document.getElementById("deleteCancel")?.click();
  alertMessage.value = "null";
  alertState.value = "neutral";

  isLoading.value = true;
  const data = { id: deleteId.value };

  FAQInfoDataService.deleteFAQ(data)
    .then((response: ResponseData) => {
      var newFAQList = Array.from(faqList);
      faqList.splice(0);
      for(let faqObj of newFAQList){
        if(deleteId.value != faqObj.id){
          faqList.push(faqObj);
        }
      }

      alertMessage.value = i18n.t("suc019");
      alertState.value = "success";
      isLoading.value = false;
    })
    .catch((e: Error) => {
      alertMessage.value = i18n.t("err032");
      alertState.value = "error";
      isLoading.value = false;
    });
};

const selectFileButton = () => {
  document.getElementById("inputFile").click();
};

// ファイル選択時の処理関数
const selectFile = (event) => {
  uploadFile.splice(0);
  var file = event.target.files[0];
  content.value = file.name;
  uploadFile.push(file);
};

const __returned__ = { isLoading, alertMessage, alertState, menuTitle, faqList, currentFile, currentSubject, modalTitle, buttonName, i18n, rowId, subject, content, uploadFile, todayDate, deleteId, subjectError, fileContentError, handleResize, getAllFAQ, onClickAddButton, onClickEditButton, clearErrorMsg, isInputOk, AddFAQ, updateFAQ, getDeleteId, deleteFAQ, selectFileButton, selectFile, AdminNavigation, Loading, Alert }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})